/**
 * Temps restant d'un examen, calculé à partir de l'échéance et non en décomptant des ticks :
 * les navigateurs espacent les timers des onglets cachés, un décompte ralentirait donc le chrono.
 * Arrondi à la seconde supérieure pour n'afficher 00:00 qu'une fois l'échéance réellement atteinte.
 */
export function secondsUntil(deadlineMs: number, nowMs: number): number {
    return Math.max(0, Math.ceil((deadlineMs - nowMs) / 1000));
}

/** Seuil de l'alerte « Plus que 5 minutes ». */
export const TIME_WARNING_SECONDS = 5 * 60;

/**
 * L'échéance après une pause du chrono (Entraînement IA, pendant qu'une question se génère) : repoussée de la
 * durée de la pause, pour que l'élève ne perde pas le temps d'attente. Jamais avancée.
 */
export function deadlineAfterHold(deadlineMs: number, heldSinceMs: number, nowMs: number): number {
    return deadlineMs + Math.max(0, nowMs - heldSinceMs);
}
